export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-white"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
                Secure VPN Solution
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight">
              Browse Freely,
              <br />
              Stay Protected
            </h1>

            <p className="text-lg text-gray-600 leading-relaxed">
              Experience ultimate online privacy and security with AGIT VPN. Military-grade encryption, lightning-fast speeds, and a strict no-log policy to keep your data safe.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('download')}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold hover:shadow-xl transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Download Now
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-lg font-semibold hover:border-blue-600 hover:text-blue-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>

            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-blue-600 text-xl"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">256-bit Encryption</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-green-600 text-xl"></i>
                </div>
                <span className="text-sm font-medium text-gray-700">No-Log Policy</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative bg-gradient-to-br from-blue-500 to-purple-600 rounded-3xl p-8 shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ae925fe4c8bb6e841ee2e024dabc813e.jpg"
                alt="VPN Security Visualization"
                className="w-full h-auto rounded-2xl object-cover"
              />
              
              <div className="absolute top-8 right-8 bg-white rounded-xl shadow-lg p-4 animate-pulse">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-sm font-semibold text-gray-800">Connected</span>
                </div>
              </div>

              <div className="absolute bottom-8 left-8 bg-white rounded-xl shadow-lg p-4">
                <div className="flex items-center gap-3">
                  <i className="ri-global-line text-blue-600 text-2xl"></i>
                  <div>
                    <p className="text-xs text-gray-500">Server Location</p>
                    <p className="text-sm font-semibold text-gray-800">50+ Countries</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
